export default "__VITE_PUBLIC_ASSET__27a0a30d__"